import React, { useState } from 'react';
import { Layers } from '@mui/icons-material'
import {
    Menu,
    MenuItem,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Typography,
    Radio,
    RadioGroup,
    Divider
} from '@mui/material';
import { LayersIconButton } from '../style/map_components';
import { BSN_LAYER_LIST, BSN_TEL_LAYER_LIST, DRONE_SHARING_LAYER_LIST } from '../const/map_config'

const MapSelectLayersIcon = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [baseMapType, setBaseMapType] = useState('satellite');

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };

    const handleChange = (event) => {
        const { name, checked: isChecked } = event.target;
        if (props.setSelectLayerList) {
            props.setSelectLayerList(prev => ({
                ...prev,
                [name]: isChecked,
            }));
        }
    };

    // どのレイヤーリストを表示するか判定（chronology の場合は空にする）
    let layerList = [];
    if (props.pageType === 'river') {
        layerList = BSN_TEL_LAYER_LIST;
    } else if (props.pageType === 'drone') {
        layerList = DRONE_SHARING_LAYER_LIST;
    } else if (props.pageType === 'chronology' || props.pageType === 'sheleter_analysis') {
        layerList = []; // chronology ではレイヤーリストを表示しない
    } else {
        layerList = BSN_LAYER_LIST;
    }

    const handleBaseMapChange = (e) => {
        const value = e.target.value;
        setBaseMapType(value);
        if (props.onChangeBaseMap) {
            props.onChangeBaseMap(value);
        }
    };

    const iconStyle = { width: '21px', height: '21px' }

    return (
        <>
            <LayersIconButton onClick={handleClick}>
                <Layers sx={iconStyle} />
            </LayersIconButton>
            <Menu
                id="long-menu"
                MenuListProps={{ 'aria-labelledby': 'long-button' }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClick}
                slotProps={{ paper: { style: { maxHeight: 48 * 4.5 } } }}
            >
                <FormGroup>
                    {(props.pageType === 'drone' || props.pageType === 'chronology' || props.pageType === 'sheleter_analysis') && (
                        <>
                            <MenuItem sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 0.5, pr: 0.5, py: 0, m: 0, gap: 0 }}>
                                <RadioGroup
                                    value={baseMapType}
                                    onChange={handleBaseMapChange}
                                    name="base-map-group"
                                    sx={{ gap: 0, p: 0, m: 0 }}
                                >
                                    <FormControlLabel
                                        value="satellite"
                                        control={<Radio size="small" sx={{ p: 0, mr: 0 }} />}
                                        label={<Typography sx={{ fontSize: '12px', ml: 0 }}>衛星写真</Typography>}
                                        sx={{ m: 0, mb: 1, py: 0, width: '100%' }}
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="pale"
                                        control={<Radio size="small" sx={{ p: 0, mr: 0 }} />}
                                        label={<Typography sx={{ fontSize: '12px', ml: 0 }}>電子国土基本図</Typography>}
                                        sx={{ m: 0, py: 0, width: '100%' }}
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </MenuItem>
                            {(props.pageType === 'drone') && (
                                <Divider sx={{ borderColor: 'rgba(0,0,0,0.25)' }} />
                            )}
                        </>
                    )}

                    {layerList.length > 0 && layerList.map((item) => (
                        <MenuItem key={item.category}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        sx={{ padding: 0 }}
                                        name={item.category}
                                        checked={props.selectLayerList?.[item.category] || false}
                                        onChange={handleChange}
                                    />
                                }
                                label={
                                    <Typography sx={{ fontSize: '12px' }}>
                                        {item.name}
                                    </Typography>
                                }
                            />
                        </MenuItem>
                    ))}
                </FormGroup>
            </Menu>
        </>
    );
};

export default MapSelectLayersIcon;